// extracted by mini-css-extract-plugin
export var icon = "_4d-1";
export var subtext = "_4d-0";